module.exports = __webpack_public_path__ + "static/media/Cascade.a8b4dcc3.png";